import { render } from "./CalculatorPersonLamal.vue?vue&type=template&id=6d66234f"
import script from "./CalculatorPersonLamal.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonLamal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__